(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('PermissionGroupFranchiserFormController', PermissionGroupFranchiserFormController)

    /** @ngInject */
    function PermissionGroupFranchiserFormController($state, $filter, $q, $stateParams, LoadingHelper, PermissionGroupService, sweetAlert, UtilHelper, ModuleService) {
        const vm = this;
        const permissionGroupId = $stateParams.permissionGroupId;

        vm.savePermissionGroup = () => {
            LoadingHelper.startLoading('.loading-holder');

            if (!vm.permissionGroupData.Id) {
                PermissionGroupService
                    .post(vm.permissionGroupData)
                    .then(success => successCallback(success, true), errorCallback);
            } else {
                let permissionGroupData = {
                    Id: permissionGroupId,
                    Description: vm.permissionGroupData.Description
                };

                ClusterService
                    .put(permissionGroupData)
                    .then(success => successCallback(success, false), errorCallback);
            }
        }

        vm.savePermissions = () => {
            LoadingHelper.startLoading('.loading-holder');

            let permissionData = vm.permissions.filter(x => x.IsView);

            PermissionGroupService
                .postPermissions(permissionData, permissionGroupId)
                .then(() => {
                    LoadingHelper.stopLoading('.loading-holder');
                    UtilHelper.successCallback();
                }, error => {
                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.loading-holder');
                })
        }

        vm.changeTab = tabId => {
            vm.selectedTab = tabId;
        }

        vm.onCheckAll = () => {
            for (let index = 0; index < vm.permissions.length; index++) {
                const permission = vm.permissions[index];

                permission.IsView = vm.getAll;
                permission.IsEdit = vm.getAll;
            }
        }

        vm.deletePermissionGroup = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    LoadingHelper.startLoading('.loading-holder');

                    PermissionGroupService
                        .deleteData(permissionGroupId)
                        .then(() => {
                            $state.go('app.franchiser-permission-groups-list')
                            LoadingHelper.stopLoading('.loading-holder');
                            UtilHelper.successCallback('delete');
                        }, error => {
                            UtilHelper.errorCallback(error);
                            LoadingHelper.stopLoading('.loading-holder');
                        })
                }
            })
        }

        init();

        function successCallback(success, isPost) {
            if (isPost) {
                vm.permissionGroupData = success;

                $state.go('app.franchiser-permission-groups-edit', {
                    permissionGroupId: vm.permissionGroupData.Id
                }, {
                    notify: false
                });

                getPermissions();

                UtilHelper.successCallback('create');
            } else {
                UtilHelper.successCallback('update');
            }

            LoadingHelper.stopLoading('.loading-holder');
        }

        function errorCallback(error) {
            LoadingHelper.stopLoading('.loading-holder');
            UtilHelper.errorCallback(error);
        }

        function getPermissionGroup() {
            if (!permissionGroupId) {
                LoadingHelper.stopLoading('.loading-holder');
                return;
            }

            return PermissionGroupService
                .get(permissionGroupId)
                .then(success => {
                    vm.permissionGroupData = success;
                }, error => {
                    LoadingHelper.stopLoading('.loading-holder');
                    UtilHelper.errorCallback(error);
                })
        }

        function getModules() {
            return ModuleService
                .getAll()
                .then(success => {
                    const modules = success.filter(x => x.ParentModuleId == null);
                    vm.modules = $filter('orderBy')(modules, 'Title', false);
                }, error => {
                    LoadingHelper.stopLoading('.loading-holder');
                    UtilHelper.errorCallback(error);
                })
        }

        function getPermissions() {
            return PermissionGroupService
                .getPermissions(vm.permissionGroupData.Id)
                .then(success => {
                    let permissions = success;

                    for (let index = 0; index < vm.modules.length; index++) {
                        const module = vm.modules[index];
                        const permission = permissions.find(x => x.ModuleId == module.Id);

                        if (!permission) {
                            permissions.push({
                                PermissionGroupId: vm.permissionGroupData.Id,
                                IsView: null,
                                IsEdit: null,
                                Module: module,
                                ModuleId: module.Id
                            })
                        } else {
                            permission.IsView = true;
                        }
                    }

                    vm.permissions = $filter('orderBy')(permissions, 'Module.IsFranchisee', false);
                    LoadingHelper.stopLoading('.loading-holder');
                }, error => {
                    LoadingHelper.stopLoading('.loading-holder');
                    UtilHelper.errorCallback(error);
                })
        }

        function init() {
            vm.permissionGroupData = {};
            vm.selectedTab = 1;
            vm.getAll = null;
            vm.selectOptions = [{
                Value: true,
                Description: 'SIM'
            }, {
                Value: false,
                Description: 'NÃO'
            }];

            LoadingHelper.startLoading('.loading-holder');

            $q.all([getModules(), getPermissionGroup()])
                .then(() => {
                    if (permissionGroupId)
                        getPermissions();
                })
        }
    }
}());